// Uzun süre açık kalan sekmeler (POS/terminal kiosk'ları, Electron uygulaması, el terminali
// tarayıcıları) yeni bir deploy sonrası eski JS ile çalışmaya devam eder — bu da örneğin
// utils/apiAuth.js'deki token ekleme mantığı gibi güncellemelerin o oturumlara hiç ulaşmaması
// demektir. Bu modül periyodik olarak asset-manifest.json'daki main.js hash'ini kontrol eder;
// değiştiğini görürse köşede "yeni sürüm var" bandı gösterir (aktif satışı bölmemek için
// otomatik yenilemez, kullanıcı tıklayınca sayfa yenilenir).

const CHECK_INTERVAL_MS = 3 * 60 * 1000;
const BANNER_ID = 'akik-update-banner';

const fetchMainJs = async () => {
  const res = await fetch(`/asset-manifest.json?_=${Date.now()}`, { cache: 'no-store' });
  if (!res.ok) return null;
  const data = await res.json();
  return data?.files?.['main.js'] || null;
};

const showBanner = () => {
  if (document.getElementById(BANNER_ID)) return;
  const banner = document.createElement('div');
  banner.id = BANNER_ID;
  banner.style.cssText = 'position:fixed;left:16px;bottom:16px;z-index:999999;background:#1f2937;color:#fff;'
    + 'padding:12px 16px;border-radius:8px;box-shadow:0 4px 16px rgba(0,0,0,.3);font:14px/1.4 system-ui,sans-serif;'
    + 'display:flex;align-items:center;gap:12px;max-width:360px;';
  banner.innerHTML = '<span>Yeni bir güncelleme mevcut. Uygun bir zamanda sayfayı yenileyin.</span>';
  const btn = document.createElement('button');
  btn.textContent = 'Yenile';
  btn.style.cssText = 'background:#3b82f6;color:#fff;border:none;padding:6px 12px;border-radius:6px;'
    + 'cursor:pointer;font-weight:600;white-space:nowrap;';
  btn.onclick = () => window.location.reload();
  banner.appendChild(btn);
  document.body.appendChild(banner);
};

export const startVersionCheck = () => {
  if (window.__akikVersionCheckInstalled) return;
  window.__akikVersionCheckInstalled = true;

  let baseline = null;
  const check = async () => {
    try {
      const current = await fetchMainJs();
      if (!current) return;
      if (baseline === null) {
        baseline = current;
        return;
      }
      if (current !== baseline) showBanner();
    } catch {
      // ağ hatası: sessizce yoksay, bir sonraki kontrolde tekrar dener
    }
  };

  check();
  setInterval(check, CHECK_INTERVAL_MS);
};
